import { useState } from "react";
import { Link } from "react-router-dom";
import api from "../api/axiosInstance";
import AuthLayout, { SubmitButton, AuthAlert } from "../components/AuthLayout";

// Step 1 of forgot password: the user enters their email and we ask the
// backend to send them a reset link.
export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      await api.post("/user/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const footer = (
    <>
      Remembered your password? <Link to="/login">Back to sign in</Link>
    </>
  );

  // After a successful request: hide the form and say what happens next.
  if (sent) {
    return (
      <AuthLayout
        title="Check your email"
        subtitle={`If an account exists for ${email}, we've sent a link to reset your password.`}
        footer={footer}
      >
        <AuthAlert tone="success">
          The link expires in 15 minutes and works once. If you don't see the email, check your spam folder.
        </AuthAlert>
        <button
          type="button"
          className="au-link-small au-resend"
          onClick={() => setSent(false)}
        >
          Use a different email
        </button>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout
      title="Reset your password"
      subtitle="Enter the email you signed up with and we'll send you a link to set a new password."
      footer={footer}
    >
      {error && <AuthAlert tone="error">{error}</AuthAlert>}

      <form className="au-form" onSubmit={handleSubmit}>
        <div className="au-field">
          <label className="au-label" htmlFor="forgot-email">Email</label>
          <input
            id="forgot-email"
            className="au-input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@company.com"
            autoComplete="email"
            required
          />
        </div>

        <SubmitButton loading={loading} loadingText="Sending link...">
          Send reset link
        </SubmitButton>
      </form>
    </AuthLayout>
  );
}